var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Chat',{attrs:{"title":"переписка по отчету","urlSendMessage":"repairs/chat/chat_of_report.php","urlDeleteMessage":"repairs/chat/del_message_report.php"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }